import { motion } from "framer-motion";
import service1 from "../assets/service1.webp";
import service2 from "../assets/service2.webp";
import service3 from "../assets/service3.webp";
import service4 from "../assets/service4.webp";
import service5 from "../assets/service5.webp";
import service6 from "../assets/service6.webp";

export default function Service() {
  const services = [
    {
      title: "Global Technology Consulting",
      desc: "Providing modern technology solutions and strategic consulting to support digital transformation and industrial efficiency.",
      detail:
        "We help businesses leverage modern technology to achieve efficiency, innovation, and competitiveness. Our consulting approach combines technical expertise with industry knowledge, enabling clients to adopt digital transformation strategies, optimize processes, and integrate future-ready technologies such as automation, data analytics, and advanced software solutions.",
      image: service1,
    },
    {
      title: "Strategic Supply Chain",
      desc: "Building a trusted global supply and vendor to ensure smooth business operations.",
      detail:
        "A reliable supply chain is the backbone of sustainable business operations. We build and maintain strategic global vendor partnerships to ensure clients receive consistent, high-quality, and cost-effective solutions. From sourcing trusted suppliers to managing international supply flows, our role is to connect businesses with the right partners across industries and regions.",
      image: service2,
    },
    {
      title: "Digital Infrastructure Provisioning",
      desc: "Providing resilient, scalable, and performance driven digital infrastructure tailored to support diverse applications, workload demands, and long term business growth.",
      detail:
        "This solution delivers compute ready environments, flexible resource allocation, and optimized service deployment capabilities, ensuring seamless performance for digital services, enterprise platforms, and mission critical applications empowering organizations with reliable operational stability and future proof scalability.",
      image: service3,
    },
    {
      title: "Modern Workflow Empowerment",
      desc: "Empowering organizations to enhance and streamline their workflows through solutions designed to improve coordination, efficiency, and overall operational clarity.",
      detail:
        "Our approach focuses on simplifying processes, strengthening collaboration, and enabling smoother interactions across teams and digital environments supporting businesses in achieving consistent productivity and a more unified way of working.",
      image: service4,
    },
    {
      title: "Enterprise Hardware Provisioning",
      desc: "Providing reliable access to essential enterprise grade hardware that supports operational continuity, technology readiness, and long term business performance.",
      detail:
        "We streamline the sourcing and delivery of high quality technology components, ensuring organizations receive the right equipment efficiently and consistently empowering smoother workflows, stable infrastructure integration, and improved operational efficiency.",
      image: service5,
    },
    {
      title: "Multi Sector Resource Enablement",
      desc: "Empowering organizations across diverse industries with tailored solution support designed to strengthen operational capability, elevate performance, and adapt to evolving business needs.",
      detail:
        "We provide comprehensive assistance in identifying, aligning, and implementing the right solutions for various sectors ensuring each organization receives the functional support required to enhance productivity, improve workflow stability, and achieve long term strategic growth.",
      image: service6,
    },
  ];

  return (
    <div className="flex flex-col items-center pt-14 px-6 text-center bg-white dark:bg-gray-900 transition-colors duration-300">
      
      {/* Heading */}
      <h1 className="text-4xl font-bold text-blue-600 dark:text-blue-300 mb-6">
        Our Services
      </h1>

      <p className="max-w-2xl text-gray-700 dark:text-gray-300 mb-12">ig
        We provide global technology consulting, supply chain solutions, and sustainable business growth strategies.
      </p>

      {/* Cards */}
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mb-20">
        {services.map((service, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.02 }}
            className="
              bg-white 
              dark:bg-white/10 dark:backdrop-blur-md 
              dark:border dark:border-white/10
              rounded-2xl shadow-lg p-8 text-left 
              hover:shadow-2xl transition
            "
          >
            <h3 className="text-xl font-semibold text-blue-600 dark:text-blue-300 mb-4">
              {service.title}
            </h3>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {service.desc}
            </p>
          </motion.div>
        ))}
      </div>

      {/* Detailed Sections */}
      <div className="w-full">
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className={`
              w-full py-16 transition-colors
              ${index % 2 === 0 
                ? "bg-blue-50 dark:bg-gray-800/60" 
                : "bg-white dark:bg-gray-900"
              }
            `}
          >
            <div
              className={`
                max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12 
                ${index % 2 === 1 ? "md:flex-row-reverse" : ""}
              `}
            >
              {/* Text */}
              <div className="md:w-1/2 text-left px-6">
                <h2 className="text-2xl font-bold text-blue-600 dark:text-blue-300 mb-4">
                  {service.title}
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed text-justify">
                  {service.detail}
                </p>
              </div>

              {/* Image */}
              <div className="md:w-1/2 px-6">
                <img
                  src={service.image}
                  alt={service.title}
                  className="rounded-xl shadow-md object-cover w-full h-80"
                />
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
